import { render } from "./keysound.vue?vue&type=template&id=7a4f38be&scoped=true"
import script from "./keysound.vue?vue&type=script&lang=js"
export * from "./keysound.vue?vue&type=script&lang=js"

import "./keysound.vue?vue&type=style&index=0&id=7a4f38be&lang=scss&scoped=true"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4f38be"]])

export default __exports__